import "@babel/polyfill";
import React from "react";
import ReactDOM from "react-dom";
import ScrollProgressBar from "./components/ScrollProgress/ScrollProgress.js";

ReactDOM.render(<ScrollProgressBar visiThrottle={750} />, document.getElementById("scrollProgressBar"));

